import * as Yup from 'yup'

const TermsConditionFormSchema = Yup.object().shape({
  acceptedTerms: Yup.boolean().required('Required').oneOf([true], 'Required')
})

export default TermsConditionFormSchema
